import { observable, action, computed, runInAction } from 'mobx';
import util from 'preact-util';

class BreeceStore {
    @observable products = [];
    @observable loading = false;
    @observable error = null;

    constructor() {
        this.name = 'breece';
    }

    @action
    async saveCredentials({ clientId, clientSecret, installationId, environment = 'production' }) {
        this.loading = true;
        this.error = null;

        try {
            const response = await util.fetchApi('/api/integrations/breece/save-credentials', {
                method: 'POST',
            }, {
                clientId,
                clientSecret,
                installationId,
                environment,
            });

            if (response.status === 200) {
                console.log('Breece Cloud credentials saved successfully');
                // Reload user info to get updated customer data BEFORE updating UI state
                const userStore = require('./user').default;
                await userStore.getInfo();
            }

            runInAction(() => {
                if (response.status !== 200) {
                    this.error = response.message || 'Failed to save credentials';
                }
                this.loading = false;
            });

            return response;
        } catch (error) {
            runInAction(() => {
                this.error = error.message;
                this.loading = false;
            });
            throw error;
        }
    }

    @action
    async revokeCredentials() {
        this.loading = true;
        this.error = null;

        try {
            const response = await util.fetchApi('/api/integrations/breece/revoke', {
                method: 'POST',
            });

            if (response.status === 200) {
                console.log('Breece Cloud credentials revoked successfully');
                // Reload user info to get updated customer data BEFORE updating UI state
                const userStore = require('./user').default;
                await userStore.getInfo();
            }

            runInAction(() => {
                if (response.status !== 200) {
                    this.error = response.message || 'Failed to revoke credentials';
                }
                this.loading = false;
            });

            return response;
        } catch (error) {
            runInAction(() => {
                this.error = error.message;
                this.loading = false;
            });
            throw error;
        }
    }

    @action
    async getProducts() {
        this.loading = true;
        this.error = null;

        try {
            const response = await util.fetchApi('/api/integrations/breece/products');

            runInAction(() => {
                if (response.status === 200) {
                    this.products = response.data || [];
                } else {
                    this.error = response.message || 'Failed to fetch products';
                }
                this.loading = false;
            });

            return response;
        } catch (error) {
            runInAction(() => {
                this.error = error.message;
                this.loading = false;
            });
            throw error;
        }
    }

    @action
    async syncProducts({ productIds, search, category, account, limit }) {
        this.loading = true;
        this.error = null;

        try {
            const response = await util.fetchApi('/api/integrations/breece/products/sync', {
                method: 'POST',
            }, {
                productIds,
                search,
                category,
                account,
                limit,
            });

            runInAction(() => {
                if (response.status !== 200) {
                    this.error = response.message || 'Failed to sync products';
                }
                this.loading = false;
            });

            return response;
        } catch (error) {
            runInAction(() => {
                this.error = error.message;
                this.loading = false;
            });
            throw error;
        }
    }

    @computed
    get hasCredentials() {
        const userStore = require('./user').default;
        return !!(userStore.customer?.breeceCredentials?.clientId);
    }

    @computed
    get environment() {
        const userStore = require('./user').default;
        return userStore.customer?.breeceCredentials?.environment || 'production';
    }
}

const store = new BreeceStore();
export default store;
